"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class CustomFieldData extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'customFieldData';
        this._customFieldTypeId = initParams.custom_field_type_id;
        this._total = initParams.total;
        this._noSitesHaveFieldType = initParams.no_sites_have_field_type;
        this._sitesWithoutFieldType = (0, util_1.camelArray)(initParams.sites_without_field_type);
    }
    set customFieldTypeId(value) {
        console.error('Do not set objects this way');
    }
    get customFieldTypeId() {
        return this._customFieldTypeId;
    }
    set total(value) {
        console.error('Do not set objects this way');
    }
    get total() {
        return this._total;
    }
    set noSitesHaveFieldType(value) {
        console.error('Do not set objects this way');
    }
    get noSitesHaveFieldType() {
        return this._noSitesHaveFieldType;
    }
    set sitesWithoutFieldType(value) {
        console.error('Do not set objects this way');
    }
    get sitesWithoutFieldType() {
        return this._sitesWithoutFieldType;
    }
}
exports.default = CustomFieldData;
//# sourceMappingURL=customFieldData.js.map